export default __webpack_public_path__ + "static/media/joyce-adams-eF_3z15RmWY-unsplash.2c47ba18.png";